﻿export class Investment {
  REQUEST_ID: number;
  BORROWER_ID: number;

}
